import React, { Component } from 'react'
import { stringify } from 'querystring'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'
import LBUMap from './LBUMap'

import './EditAddress.css'

const parseLocation = (str) => {
    return str.split(',').reverse().map(parseFloat)
}

class EditAddress extends Component {

    state = {
        streetName: this.props.streetName,
        streetNumber: this.props.streetNumber,
        level: this.props.level,
        postalCode: this.props.postalCode,
        postalArea: this.props.postalArea,
        location: this.props.location
    }

    onSave = () => {
        this.props.onSave(Object.assign({}, this.state, {
            location: this.state.location.join(',')
        }))
    }

    geocode = async () => {
        const {
            streetName = '',
            streetNumber = '',
            postalArea = ''
        } = this.state

        const params = {
            key: process.env.REACT_APP_GOOGLE_API_KEY,
            address: [streetName, streetNumber, postalArea].join('+')
        }

        try {
            const res = await fetch('https://maps.googleapis.com/maps/api/geocode/json?' + stringify(params)).then(res => res.json())
            const { lng, lat } = res.results[0].geometry.location

            this.setState({
                location: [
                    Math.round(lng * 1e6) / 1e6,
                    Math.round(lat * 1e6) / 1e6
                ]
            })
        } catch (err) {
            alert(err.message)
        }
    }

    render() {
        const {
            streetName = '',
            streetNumber = '',
            level = '',
            postalCode = '',
            postalArea = '',
            location = [0, 0]
        } = this.state

        const [lng, lat] = location

        return (
          <Modal
            extraClassName="EditAddress"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Address">
            <Form>
                <div>
                    <label>Street name</label>
                    <input
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        type="text"
                        placeholder="Street name"
                        value={streetName}
                        onChange={e => this.setState({ streetName: e.target.value })} />
                </div>
                <div>
                    <label>Street number</label>
                    <input
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        type="text"
                        placeholder="Street number"
                        value={streetNumber}
                        onChange={e => this.setState({ streetNumber: e.target.value })} />
                </div>
                <div>
                    <label>Commercial District</label>
                    <input
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Commercial District"
                        value={level}
                        onChange={e => this.setState({ level: e.target.value })} />
                </div>
                <div>
                    <label>Postal code</label>
                    <input
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Postal code"
                        value={postalCode}
                        onChange={e => this.setState({ postalCode: e.target.value })} />
                </div>
                <div>
                    <label>Postal area</label>
                    <input
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Postal area"
                        value={postalArea}
                        onChange={e => this.setState({ postalArea: e.target.value })} />
                </div>
                <div>
                    <label>Location (lat,lon)</label>
                    <input
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Location"
                        value={[lat, lng].join(',')}
                        onChange={e => this.setState({ location: parseLocation(e.target.value) })} />
                    <button className="geocodeButton" onClick={this.geocode}>Geocode address</button>
                    <LBUMap
                        location={location}
                        onChange={location => this.setState({ location })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditAddress



// WEBPACK FOOTER //
// ./src/components/LBUs/EditAddress.js